// Sentry must be initialized FIRST
import { initSentry } from "@/sentry";
initSentry();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global error handler to suppress third-party errors (PostHog, analytics, etc.)
// and prevent them from showing ugly error screens to users
window.addEventListener('error', (event) => {
  // Check if error is from third-party scripts
  const thirdPartyDomains = [
    'posthog.com',
    'sentry.io',
    'googletagmanager.com',
    'google-analytics.com',
    'hotjar.com',
    'intercom.io',
    'crisp.chat'
  ];
  
  const errorSource = event.filename || '';
  const isThirdPartyError = thirdPartyDomains.some(domain => errorSource.includes(domain));
  
  // Also check for specific known non-critical errors
  const nonCriticalErrors = [
    'PerformanceServerTiming',
    'ResizeObserver loop',
    'Script error',
    'ChunkLoadError'
  ];
  const errorMessage = event.message || '';
  const isNonCriticalError = nonCriticalErrors.some(err => errorMessage.includes(err));
  
  if (isThirdPartyError || isNonCriticalError) {
    // Prevent the error from propagating
    event.preventDefault();
    // Still log it for debugging
    console.warn('[Suppressed third-party error]:', errorMessage);
    return false;
  }
});

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || String(event.reason) || '';
  
  // Suppress non-critical promise rejections
  const suppressedMessages = [
    'PerformanceServerTiming',
    'postMessage',
    'ResizeObserver',
    'Loading chunk'
  ];
  
  if (suppressedMessages.some(msg => errorMessage.includes(msg))) {
    event.preventDefault();
    console.warn('[Suppressed unhandled rejection]:', errorMessage);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
